import { render, staticRenderFns } from "./RuleStatisticCard.vue?vue&type=template&id=a3ac0d28&scoped=true&"
import script from "./RuleStatisticCard.vue?vue&type=script&lang=js&"
export * from "./RuleStatisticCard.vue?vue&type=script&lang=js&"
import style0 from "./RuleStatisticCard.vue?vue&type=style&index=0&id=a3ac0d28&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a3ac0d28",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VIcon})
